<ion-header class="ion-no-border">
  <app-vendor-header></app-vendor-header>
</ion-header>
<ion-content class="bg-color ion-content profile">
  <div class="com-content">
    <div class="content-breadcrumb">
      <ul class="breadcrumb">
        <li *ngFor="let itemList of breadcrumbList" class="breadcrumb-item">
          <ng-container *ngIf="itemList.embedurl; else noRoute">
            <a href="javascript:void(0)" routerLink="{{ itemList.url }}">
              {{ itemList.label }}
            </a>
          </ng-container>
          <ng-template #noRoute>
            <a style="text-decoration: none; cursor: none;" href="javascript:void(0)">
              {{ itemList.label }}
            </a>
          </ng-template>
        </li>
      </ul>
    </div>
    <div class="content-grid">
      <div class="m-content">
        <form [formGroup]="updateProfileform" (ngSubmit)="onSubmit()">
          <mat-card>
            <mat-card-content class="mc-content">
              <div class="form-container" style="background-color: #fbfbfb; border: 1px solid #f0f0f8;">
                <div class="logo-layout">
                  <div class="image-xe profile-image">
                    <div class="p-image">
                      <img [src]="profileImagePath">
                      <mat-icon *ngIf="isEnableProfileImageChanges" class="clear-image" (click)="clearProfileImage()">highlight_off</mat-icon>
                    </div>
                    <div class="file-upload">
                      <input type="file" id="profile_image" #profileImage (change)="uploadProfileImage($event)" accept="image/x-png,image/jpeg">
                    </div>
                    <p style="color: #000000; padding: 10px 0;">Profile image upload file format of jpg, jpeg and png only upto size of 200KB</p>
                  </div>

                </div>
              </div>
              <div class="form-container">
                  <div class="form-layout">
                    <mat-form-field appearance="outline">
                      <mat-label>First name</mat-label>
                      <input type="text" id="profile_firstname" formControlName="firstName" matInput placeholder="First name" required>
                      <mat-error *ngIf="updateProfileform.get('firstName').hasError('pattern')">
                        First Name Allows Alphanumeric Only!
                      </mat-error>
                      <mat-error *ngIf="updateProfileform.get('firstName').hasError('required')">
                        First Name is Required!
                      </mat-error>
                    </mat-form-field>
                    <mat-form-field appearance="outline">
                      <mat-label>Last name</mat-label>
                      <input type="text" id="profile_lastname" formControlName="lastName" matInput placeholder="Last name" required>
                      <mat-error *ngIf="updateProfileform.get('lastName').hasError('pattern')">
                        Last Name Allows Alphanumeric Only!
                      </mat-error>
                      <mat-error *ngIf="updateProfileform.get('lastName').hasError('required')">
                        Last Name is Required!
                      </mat-error>
                    </mat-form-field>
                  </div>
                  <div class="form-layout">
                    <mat-form-field appearance="outline">
                      <mat-label>Work email</mat-label>
                      <input type="text" id="profile_email" formControlName="email" matInput placeholder="Work email Address" required readonly>
                    </mat-form-field>
                    <mat-form-field appearance="outline">
                      <mat-label>Phone number</mat-label>
                      <input type="text" id="profile_phone" minlength="10" maxlength="18" formControlName="phone" matInput placeholder="Phone number" required>
                      <mat-error *ngIf="updateProfileform.get('phone').hasError('required')">
                        Phone Number is Required!
                      </mat-error>
                      <mat-error *ngIf="updateProfileform.get('phone').hasError('minlength')">
                        Please Enter a Valid 10 digit Phone Number
                      </mat-error>
                      <mat-error *ngIf="updateProfileform.get('phone').hasError('maxlength')">
                        Maximum length should be 18 digits
                      </mat-error>
                    </mat-form-field>
                  </div>
                  <div class="form-layout">
                    <mat-form-field appearance="outline">
                      <mat-label>Job Title</mat-label>
                      <mat-select formControlName="jobTitle" id="profile_job" required>
                        <mat-option>-- Select --</mat-option>
                        <mat-option *ngFor="let job of jobTitle" value="{{job.name}}">{{job.name}}</mat-option>
                      </mat-select>
                    </mat-form-field>
                    <mat-form-field appearance="outline">
                      <mat-label>Employee</mat-label>
                      <mat-select formControlName="employee" id="profile_employee" required>
                        <mat-option>-- Select --</mat-option>
                        <mat-option *ngFor="let emp of employee" value="{{emp.name}}">{{emp.name}}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div class="form-layout">
                    <mat-form-field appearance="outline">
                      <mat-label>Company</mat-label>
                      <input type="text" id="profile_company" formControlName="company" matInput placeholder="Company" required>
                      <mat-error *ngIf="updateProfileform.get('company').hasError('required')">
                        Company Name Is Required!
                      </mat-error>
                    </mat-form-field>
                    <mat-form-field appearance="outline">
                      <mat-label>Country</mat-label>
                      <mat-select formControlName="country" id="profile_country" required>
                        <mat-option>-- Select --</mat-option>
                        <mat-option *ngFor="let country of countries" value="{{country.country_name}}">{{country.country_name}}</mat-option>
                      </mat-select>
                      <mat-error *ngIf="updateProfileform.get('country').hasError('required')">
                        Country Name Is Required!
                      </mat-error>
                    </mat-form-field>
                    <!-- <mat-label class="mfa_toggle">Enable Multi Factor Authentication</mat-label><br>
                    <mat-slide-toggle class="mfa_toggle" color="danger" #toggle formControlName="mfa_enabled"
                    (change)="enableMfaToggle($event)"></mat-slide-toggle> -->
                  </div>

                  <div class="btn-signup-grid">
                    <button mat-raised-button type="submit" id="profile_submit" class="btn btn-signup">Update</button>
                  </div>
              </div>
            </mat-card-content>
          </mat-card>
        </form>
      </div>
    </div>
    <app-footer></app-footer>
  </div>
</ion-content>